import React from 'react';
import './nested_spinner.scss';
const NestedSpinner = () => {
    return (React.createElement("div", { className: "nested_spinner xss:ml-auto xss:mr-auto" }));
};
export default NestedSpinner;
